"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var StyledBlob = _styledComponents.default.div.withConfig({
  displayName: "StyledBlob",
  componentId: "sc-19esj0s-0"
})(["background-color:", ";height:458px;z-index:-1;border-bottom-left-radius:100%;border-bottom-right-radius:100%;"], _colors.GYPSUM);

var _default = StyledBlob;
exports.default = _default;
module.exports = exports.default;